import * as React from 'react';
import classNames from 'classnames';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';
import { withStyles, WithStyles, Theme, createStyles } from '@material-ui/core/styles';
import { CSSProperties } from 'react';
import { Subtract } from 'utility-types';

const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
};

const styles = (theme: Theme) => createStyles({
    success: {
        backgroundColor: green[600],
    },
    error: {
        backgroundColor: theme.palette.error.dark,
    },
    info: {
        backgroundColor: theme.palette.primary.dark,
    },
    warning: {
        backgroundColor: amber[700],
    },
    icon: {
        fontSize: 20,
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(),
    },
    message: {
        display: 'flex',
        alignItems: 'center',
    },
});

export type ToastType = 'warning' | 'info' | 'error' | 'success'
interface ToastProps extends WithStyles<typeof styles> {
    onClose?: () => void
    variant: ToastType
    className?: string;
    message: string;
    style?: CSSProperties
}
interface ToastState {
    open: boolean
}
class Toast extends React.Component<ToastProps, ToastState> {
    state = {
        open: true
    };
    handleClick = () => {
        this.setState({ open: true });
    };

    handleClose = (_event: any, reason: string) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ open: false });
        this.props.onClose && this.props.onClose()
    };

    public render() {
        const { classes, className, message, onClose, variant, style } = this.props;
        const Icon = variantIcon[variant];
        return (
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                style={style}
                open={this.state.open}
                autoHideDuration={6000}
                onClose={this.handleClose}>
                <SnackbarContent
                    className={classNames(classes[variant], className)}
                    aria-describedby="client-snackbar"
                    message={
                        <span id="client-snackbar" className={classes.message}>
                            <Icon className={classNames(classes.icon, classes.iconVariant)} />
                            {message}
                        </span>
                    }
                    action={[
                        <IconButton
                            key="close"
                            aria-label="Close"
                            color="inherit"
                            onClick={onClose}>
                            <CloseIcon className={classes.icon} />
                        </IconButton>,
                    ]}
                />
            </Snackbar>
        );
    }
}
const ToastComponent = withStyles(styles)(Toast)

export interface WithToast {
    showToast: (type: ToastType, message: string) => void;
}
let currentToastId = 0

export function withToast<P extends WithToast>(WrappedComponent: React.ComponentType<P>): React.ComponentClass<Subtract<P, WithToast>> {
    return class extends React.Component<Subtract<P, WithToast>, { toasts: { type: ToastType, message: string, id: number, height?: number }[] }> {

        constructor(props: any) {
            super(props);
            this.state = {
                toasts: []
            };
        }

        get offsets() {
            const { toasts } = this.state;
            return toasts.map((item, i) => {
                let index = i;
                let offset = 20;
                while (toasts[index - 1]) {
                    offset += (toasts[index - 1].height || 56) + 16;
                    index -= 1;
                }
                return offset;
            });
        }

        public render() {
            return (<>
                {this.state.toasts.map((toast, i) => {
                    return <ToastComponent style={{ marginBottom: this.offsets[i] }} key={toast.id} message={toast.message} variant={toast.type} onClose={() => {
                        this.setState({
                            toasts: this.state.toasts.filter(t => t.id != toast.id)
                        })
                    }} />
                })}

                <WrappedComponent  {...this.props as any} showToast={(type: ToastType, message: string) => {
                    this.setState({
                        toasts: this.state.toasts.concat([{ type, message, id: currentToastId++ }])
                    })
                }} />
            </>
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/HOC/Toast.tsx